import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import Template from '../components/Template'
import { Tabs, Tab, Button, Form, Alert, Table, Dropdown } from 'react-bootstrap'
import Modal from '../components/Modal'
import Loader from '../components/Loader'
import Popup from '../components/PopupMessage'
import Pagination from '../components/Pagination'
import UserInfo from '../components/UserInfo'
import MemberData from '../components/MemberData'
import EventAdminPanel from '../components/EventAdminPanel'
import NotificationAdminPanel from '../components/NotificationAdminPanel'
import {
    userGenerateFamilyCSV,
    memberGetAll,
    deleteMember,
    userGenerateData
} from '../actions/memberActions'
import { userGetAll } from '../actions/userActions'
import {
    MEMBER_GENERATE_CSV_CLEAR,
    MEMBER_DELETE_CLEAR
} from '../constants/memberConstant'

const Admin = () => {
    const [isDeleteOn, setIsDeleteOn] = useState(false)
    const [deleteId, setDeleteId] = useState('')
    const [memberFirstName, setMemberFirstName] = useState('')
    const [memberSortText, setMemberSortText] = useState('')
    const [userFirstName, setUserFirstName] = useState('')
    const [userSortText, setUserSortText] = useState('')

    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()
    const { user: { data } } = useSelector(state => state.login)

    const { csvData } = useSelector(state => state.generateCSV)
    const { loading: loading_m, error: error_m, membersData } = useSelector(state => state.members)
    const { loading: loading_u, error: error_u, usersData } = useSelector(state => state.users)
    const { loading: loading_d, error: error_d, message: message_d } = useSelector(state => state.deleteMember)
    const { success } = useSelector(state => state.activate)
    const { success: success_p } = useSelector(state => state.promote)
    const { success: success_public } = useSelector(state => state.publicAccount)
    const { success: success_r } = useSelector(state => state.remove)
    const { success: success_l } = useSelector(state => state.linkMember)

    const deleteMemberHandler = () => {
        if (deleteId.trim()) dispatch(deleteMember(deleteId.trim()))
    }

    const memberSearchUrl = (key, value) => {
        const search = new URLSearchParams(location.search)
        if (search.has(key)) search.delete(key)
        if (key !== 'page') search.delete('page')
        search.append(key, value)
        return search.toString()
    }

    const memberSortHandler = (value, d) => {
        if (d === 'all') {
            history.push(location.pathname)
            setMemberSortText(value)
        } else if (d === 'men') {
            location.search
                ? history.push(`${location.pathname}?${memberSearchUrl('gender', 'm')}`)
                : history.push(`${location.pathname}?gender=m`)
            setMemberSortText(value)
        } else {
            location.search
                ? history.push(`${location.pathname}?${memberSearchUrl('gender', 'f')}`)
                : history.push(`${location.pathname}?gender=f`)
            setMemberSortText(value)
        }
    }

    const membersSearchHandler = e => {
        e.preventDefault()
        location.search
            ? history.push(`${location.pathname}?${memberSearchUrl('keyword', memberFirstName)}`)
            : history.push(`${location.pathname}?keyword=${memberFirstName}`)
        setMemberFirstName('')
    }

    const userSearchUrl = (key, value) => {
        const search = new URLSearchParams(location.search)
        if (search.has('isActive') && key === 'isCoAdmin') search.delete('isActive')
        if (search.has('isCoAdmin') && key === 'isActive') search.delete('isCoAdmin')
        if (key !== 'page') search.delete('page')
        search.append(key, value)
        return search.toString()
    }

    const userSortHandler = (value, d) => {
        if (d === 'all') {
            history.push(location.pathname)
            setUserSortText(value)
        } else if (d === 'active') {
            location.search
                ? history.push(`${location.pathname}?${userSearchUrl('isActive', 'true')}`)
                : history.push(`${location.pathname}?isActive=true`)
            setUserSortText(value)
        } else if (d === 'deactive') {
            location.search
                ? history.push(`${location.pathname}?${userSearchUrl('isActive', 'false')}`)
                : history.push(`${location.pathname}?isActive=false`)
            setUserSortText(value)
        } else if (d === 'CoAdmin') {
            location.search
                ? history.push(`${location.pathname}?${userSearchUrl('isCoAdmin', 'true')}`)
                : history.push(`${location.pathname}?isCoAdmin=true`)
            setUserSortText(value)
        } else {
            location.search
                ? history.push(`${location.pathname}?${userSearchUrl('isCoAdmin', 'false')}`)
                : history.push(`${location.pathname}?isCoAdmin=false`)
            setUserSortText(value)
        }
    }

    const usersSearchHandler = e => {
        e.preventDefault()
        location.search
            ? history.push(`${location.pathname}?${userSearchUrl('keyword', userFirstName)}`)
            : history.push(`${location.pathname}?keyword=${userFirstName}`)
        setUserFirstName('')
    }

    useEffect(() => {
        if (csvData) {
            const a = document.createElement('a')
            a.href = '/uploads/family-data.xlsx'
            a.download = 'family_data.xlsx'
            a.click()
            dispatch({ type: MEMBER_GENERATE_CSV_CLEAR })
        }
        if (message_d) {
            dispatch({ type: MEMBER_DELETE_CLEAR })
            dispatch(userGenerateData())
            setIsDeleteOn(false)
            setDeleteId('')
        }
    }, [csvData, message_d, dispatch])

    useEffect(() => {
        dispatch(memberGetAll(location.search))
    }, [dispatch, location])

    useEffect(() => {
        dispatch(userGetAll(location.search))
    }, [dispatch, success, success_p, success_public, success_r, success_l, location])

    return (
        <Template>
            <Modal
                heading='حذف بيانات عضو'
                show={isDeleteOn}
                onHide={() => { setIsDeleteOn(false); setDeleteId(''); dispatch({ type: MEMBER_DELETE_CLEAR }) }}
            >
                {loading_d && <Loader />}
                {error_d && <Alert variant='danger'>{error_d}</Alert>}
                {message_d
                    ? <Alert variant='success'>{message_d}</Alert>
                    : <Form>
                        <Form.Group>
                            <label htmlFor='deleteId'>أدخل معرّف العضو (ID)</label>
                            <Form.Control
                                id='deleteId'
                                type='text'
                                placeholder='مثال: 60f2c8e7131cad0723062518'
                                value={deleteId}
                                onChange={({ target: { value } }) => setDeleteId(value)}
                            />
                        </Form.Group>
                        <Alert variant='warning' style={{ marginTop: '1rem' }}>
                            تحذير: هذا الإجراء لا يمكن التراجع عنه
                        </Alert>
                        <Button variant='danger' disabled={!deleteId.trim() || loading_d} onClick={deleteMemberHandler}>
                            حذف العضو
                        </Button>
                    </Form>}
            </Modal>

            <h2 className='main__title'>لوحة الإدارة</h2>

            <Tabs defaultActiveKey='data' className='admin__tabs'>
                <Tab eventKey='data' title='إدارة الأعضاء'>
                    <div className='admin__data'>
                        <Button variant='danger' onClick={() => history.push('/new')}>
                            إضافة عضو جديد
                        </Button>
                        <Button variant='light' onClick={() => dispatch(userGenerateFamilyCSV())}>
                            تصدير بيانات الأعضاء
                        </Button>
                        <Button variant='secondary' onClick={() => setIsDeleteOn(true)}>
                            حذف بيانات عضو
                        </Button>
                    </div>
                </Tab>

                <Tab eventKey='members' title='أعضاء العائلة'>
                    <div className='users'>
                        <div className='users__sort'>
                            <Dropdown>
                                <Dropdown.Toggle variant='success' id='members-dropdown'>
                                    {memberSortText ? memberSortText : 'فلترة الاعضاء'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={({ target }) => memberSortHandler(target.innerText, 'all')}>جميع الاعضاء</Dropdown.Item>
                                    <Dropdown.Item onClick={({ target }) => memberSortHandler(target.innerText, 'men')}>الرجال</Dropdown.Item>
                                    <Dropdown.Item onClick={({ target }) => memberSortHandler(target.innerText, 'women')}>النساء</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Form className='navigation__search users__search' onSubmit={membersSearchHandler}>
                                <Form.Control
                                    type='text'
                                    placeholder='بحث بالإسم الأول'
                                    className='mr-sm-2'
                                    value={memberFirstName}
                                    onChange={({ target: { value } }) => setMemberFirstName(value)} />
                                <Button variant='outline-success'>بحث</Button>
                            </Form>
                        </div>
                        {loading_m ? <Loader />
                            : error_m ? <Popup danger><p>{error_m}</p></Popup>
                                : (<>
                                    <div className='users__table'>
                                        <Table bordered>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th><span>الإسم</span></th>
                                                    <th><span>الصورة الشخصية</span></th>
                                                    <th><span>العمر</span></th>
                                                    <th><span>الحالة الإجتماعية</span></th>
                                                    <th><span>الوظيفة</span></th>
                                                    <th><span>مدينة الاقامة</span></th>
                                                    <th><span>رقم الجوال</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {membersData && membersData.members.map((member, i) => (
                                                    <MemberData info={member} key={member._id} idx={i + 1} />
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                    {membersData && <Pagination
                                        count={membersData.membersCounts}
                                        page={membersData.page}
                                        searchHandler={memberSearchUrl}
                                    />}
                                </>)}
                    </div>
                </Tab>

                <Tab eventKey='users' title='المستخدمون'>
                    <div className='users'>
                        <div className='users__sort'>
                            <Dropdown>
                                <Dropdown.Toggle variant='success' id='users-dropdown'>
                                    {userSortText ? userSortText : 'فلترة المستخدمين'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={({ target }) => userSortHandler(target.innerText, 'all')}>إظهار جميع المستخدمين</Dropdown.Item>
                                    <Dropdown.Item onClick={({ target }) => userSortHandler(target.innerText, 'active')}>إظهار المستخدمين المفعلين</Dropdown.Item>
                                    <Dropdown.Item onClick={({ target }) => userSortHandler(target.innerText, 'deactive')}>إظهار المستخدمين الغير مفعلين</Dropdown.Item>
                                    {data && data.isAdmin && <>
                                        <Dropdown.Item onClick={({ target }) => userSortHandler(target.innerText, 'CoAdmin')}>إظهار مساعدين المدير</Dropdown.Item>
                                        <Dropdown.Item onClick={({ target }) => userSortHandler(target.innerText, 'NoCoAdmin')}>إظهار المستخدمين الغير معينيين</Dropdown.Item>
                                    </>}
                                </Dropdown.Menu>
                            </Dropdown>
                            <Form className='navigation__search users__search' onSubmit={usersSearchHandler}>
                                <Form.Control
                                    type='text'
                                    placeholder='بحث بالإسم الأول'
                                    className='mr-sm-2'
                                    value={userFirstName}
                                    onChange={({ target: { value } }) => setUserFirstName(value)} />
                                <Button variant='outline-success'>بحث</Button>
                            </Form>
                        </div>
                        {loading_u ? <Loader />
                            : error_u ? <Popup danger><p>{error_u}</p></Popup>
                                : (<>
                                    <div className='users__table'>
                                        <Table bordered>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th><span>الإسم</span></th>
                                                    <th><span>البريد الإلكترونى</span></th>
                                                    <th><span>رقم الجوال</span></th>
                                                    <th><span>عضو العائلة المرتبط</span></th>
                                                    {data && data.isAdmin && <th><span>مساعد المدير</span></th>}
                                                    {data && data.isAdmin && <th><span>حساب عام</span></th>}
                                                    <th><span>حالة الحساب</span></th>
                                                    <th><span>حذف الحساب</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {usersData && usersData.users.map((user, i) => (
                                                    <UserInfo info={user} key={user._id} ind={i} />
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                    {usersData && <Pagination
                                        count={usersData.usersCounts}
                                        page={usersData.page}
                                        searchHandler={userSearchUrl}
                                    />}
                                </>)}
                    </div>
                </Tab>

                <Tab eventKey='events' title='الفعاليات'>
                    <EventAdminPanel />
                </Tab>

                <Tab eventKey='notifications' title='الإشعارات'>
                    <NotificationAdminPanel />
                </Tab>
            </Tabs>
        </Template>
    )
}

export default Admin
